<!-- 多文件上传组件 -->
<template>
  <el-upload
    :action="upUrl"
    ref="mul-upload"
    :multiple="multiple"
    :drag="drag"
    :list-type="listType"
    :before-upload="beforeUpload"
    :on-success="sucFunc"
    :on-error="errorFunc"
    :on-remove="remFunc"
    :file-list="fileList"
  >
    <!-- :headers="{
      token: $store.getters.token,
    }" -->
    <div v-if="drag">
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
    </div>
    <div v-else>
      <el-button size="small" type="primary">点击上传</el-button>
    </div>
  </el-upload>
</template>

<script>
export default {
  props: {
    // 已上传文件预览形式 text/picture/picture-card
    listType: {
      type: String,
      default: () => "text",
    },
    multiple: {
      type: Boolean,
      default: () => false,
    },
    // 已上传文件地址
    filePath: {
      type: String,
    },
    // 文件上传地址
    upUrl: {
      type: String,
      required: true,
    },
    // 拖拽上传开关
    drag: {
      type: Boolean,
      default: () => true,
    },
  },
  data() {
    return {
      fileList: [],
    };
  },
  watch: {
    // 信息修改窗口已上传信息展示
    filePath: {
      handler(val) {
        this.fileList = [];
        if (!val) {
          this.fileList = [];
        } else {
          val.split(",").forEach((item) => {
            this.fileList.push({
              name: item
                .split("/")
                .pop()
                .split("-")[1],
              url: item,
            });
          });
        }
      },
      immediate: true,
    },
  },
  methods: {
    beforeUpload(file) {
      if (this.$tools.testFileName(file.name)) {
        this.$message.warning("文件名包含特殊字符");
        return false;
      }
    },
    sucFunc(res, file, fileList) {
      let result = "";
      fileList.forEach((item, index) => {
        if (item.url) {
          result += item.url;
        } else {
          result += item.response.data;
        }
        if (index + 1 < fileList.length) result += ",";
      });
      this.$emit("uploadRes", result);
    },
    errorFunc(err) {
      this.$message.warning(err.msg);
    },
    remFunc(res, fileList) {
      let result = "";
      fileList.forEach((item, index) => {
        result += item.response.data;
        if (index + 1 < fileList.length) result += ",";
      });
      this.$emit("uploadRes", result);
    },
  },
};
</script>

<style></style>
